// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M17 7C20.866 7 24 10.134 24 14L23.9912 14.3604C23.8097 17.9395 20.9395 20.8097 17.3604 20.9912L17 21C13.2549 21 10.1963 18.0589 10.0088 14.3604L10 14C10 10.134 13.134 7 17 7ZM16 14.4141L18.333 16.7471L19.7471 15.333L18 13.5859V11.3359H16V14.4141Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M8 20H0V18H8V20Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M8 15H0V13H8V15Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M8 10H0V8H8V10Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M24 5H0V3H24V5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-dialog-history-filled')
export default class DialogHistoryFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'dialog-history-filled',
    }
  }
}
